import { call, put, takeEvery } from 'redux-saga/effects';
import {
    GetRoomPricesApi,
    CreateRoomPriceApi,
    UpdateRoomPriceApi,
    DeleteRoomPriceApi,
    GetRoomPriceByIdApi,
} from '../../utils/api';
import { ActionGetRoomPricesListSuccess, ActionGetRoomPriceByIDSuccess } from '../Actions/RoomPriceAction';
import { handleApiResponse } from '../../utils/functions';
import {
    GET_ROOM_PRICES_LIST,
    CREATE_ROOM_PRICE,
    UPDATE_ROOM_PRICE,
    DELETE_ROOM_PRICE,
    GET_ROOM_PRICE_BY_ID,
} from '../storeTypes';

const File = 'RoomPriceSaga';

function* GetRoomPricesSaga(action) {
    try {
        const response = yield call(GetRoomPricesApi, action.payload);
        if (response?.status === 200) {
            yield put(ActionGetRoomPricesListSuccess(response?.data?.data || []));
        }
    } catch (error) {
        handleApiResponse(error?.response.status, error?.response?.data, action?.callback);
    }
}

function* CreateRoomPriceSaga(action) {
    try {
        const response = yield call(CreateRoomPriceApi, action.payload);
        if (response) {
            action?.callBack(response?.data);
        }
    } catch (error) {
        if (error?.response?.status === 400) {
            action?.callBack(error?.response?.data);
        }
    }
}

function* UpdateRoomPriceSaga(action) {
    try {
        const response = yield call(UpdateRoomPriceApi, action.payload);
        if (response?.status === 200) {
            action?.callBack(response?.data);
        }
    } catch (error) {
        if (error?.response?.status === 400) {
            action?.callBack(error?.response?.data);
        }
    }
}

function* GetRoomPriceByIDSaga(action) {
    try {
        const response = yield call(GetRoomPriceByIdApi, action.payload);
        if (response?.status === 200) {
            yield put(ActionGetRoomPriceByIDSuccess(response?.data?.data));
        }
    } catch (error) {
        handleApiResponse(error?.response.status, error?.response?.data, action?.callBack);
    }
}

function* DeleteRoomPriceSaga(action) {
    try {
        const response = yield call(DeleteRoomPriceApi, action.payload);
        if (response?.status === 200) {
            action?.callBack(200);
        }
    } catch (error) {
        console.log(File + '/DeleteRoomPriceSaga Error:', error);
    }
}

export function* RoomPriceSaga() {
    yield takeEvery(GET_ROOM_PRICES_LIST, GetRoomPricesSaga);
    yield takeEvery(CREATE_ROOM_PRICE, CreateRoomPriceSaga);
    yield takeEvery(UPDATE_ROOM_PRICE, UpdateRoomPriceSaga);
    yield takeEvery(GET_ROOM_PRICE_BY_ID, GetRoomPriceByIDSaga);
    yield takeEvery(DELETE_ROOM_PRICE, DeleteRoomPriceSaga);
}